import 'isomorphic-fetch';
import { config } from 'config';

export const api = {
	fleteros: {
		async create(data) {
			const response = await fetch(config.URL_API + '/fleteros/alta', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async estado(data) {
			const response = await fetch(config.URL_API + `/fleteros/estado`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/fleteros/id/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async update(data) {
			const response = await fetch(config.URL_API + '/fleteros/modificar', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async preparar(id) {
			const response = await fetch(config.URL_API + '/fleteros/prepararLiquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	tipodoc: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/documentos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	localidades: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/localidades&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/localidades/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	iva: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/condicionesiva&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	adelantos: {
		async imprimirCheques(id, id_banco) {
			const res = await fetch(`${config.URL_API}/adelantos_fleteros/pdfCheques/${id}/${id_banco}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async create(data) {
			const response = await fetch(config.URL_API + '/adelantos_fleteros/alta', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async estado(data) {
			const response = await fetch(config.URL_API + `/adelantos_fleteros/estado`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getPendientes(id) {
			const response = await fetch(config.URL_API + '/adelantos_fleteros/pendientes/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getLiquidados(id) {
			const response = await fetch(config.URL_API + '/adelantos_fleteros/liquidados/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/adelantos_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(`${config.URL_API}/adelantos_fleteros/adelanto/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/adelantos_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async update(data) {
			const response = await fetch(config.URL_API + '/adelantos_fleteros/modificar', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	choferes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/choferes_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + `/choferes_fleteros/choferes/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	vales: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/conceptos_vales&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	fpago: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas_bancarias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_bancarias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cheques: {
		async getAllTerceros() {
			const response = await fetch(config.URL_API + '/cheques_terceros/pendientes', {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	facturas: {
		async get(id) {
			const response = await fetch(config.URL_API + '/facturas/coprobante/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async pdf(id, mimeType) {
			const res = await fetch(config.URL_API + `/facturas/pdfComprobante/${id}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	comprobantes_tipos_fleteros: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/comprobantes/fleteros', {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	comprobantes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/facturas/coprobantesFleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async pdfComp(id, mimeType) {
			const res = await fetch(config.URL_API + '/facturas/pdfComprobanteFletero/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	clientes: {
		async create(data) {
			const response = await fetch(config.URL_API + '/facturas/liquidacionCliente', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async estado(data) {
			const response = await fetch(config.URL_API + `/clientes_fleteros/estado`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getPendientes(id) {
			const response = await fetch(config.URL_API + '/clientes_fleteros/pendientes/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getLiquidados(id) {
			const response = await fetch(config.URL_API + '/clientes_fleteros/liquidados/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/clientes_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/clientes_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async update(data) {
			const response = await fetch(config.URL_API + '/clientes_fleteros/modificar', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async resumendecuentapdf(data) {
			const res = await fetch(config.URL_API + '/clientes/resumendecuentapdf', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
				},
				body: JSON.stringify(data)
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], data.id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async resumendecuenta(data) {
			const response = await fetch(config.URL_API + '/clientes/resumendecuenta', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	acopiadores: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/acopiadores&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/acopiadores/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	camiones: {
		async getAll(id) {
			const response = await fetch(config.URL_API + `/camiones_fleteros/camiones/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	alicuotas: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/alicuotas&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	mercaderias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/mercaderias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	facturacion: {
		async create(data) {
			const response = await fetch(config.URL_API + '/facturas/liquidacionFletero', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getPendientes(id) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/pendientes/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async estado(data) {
			const response = await fetch(config.URL_API + `/facturacion_fleteros/estado`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getPendientes(id) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/pendientes/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getLiquidados(id) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/liquidados/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/facturacion_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/facturacion_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async update(data) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/modificar', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	recibo: {
		async getAllComp(id) {
			const response = await fetch(config.URL_API + '/facturas/coprobanteFletero/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getRecibo(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllLiq(id) {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async pdfComp(id, mimeType) {
			const res = await fetch(config.URL_API + '/facturas/pdfComprobanteFletero/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
		async pdfLiq(id, mimeType) {
			const res = await fetch(config.URL_API + '/liquidaciones_fleteros/pdfLiquidacion/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
		async pdfRecibo(id, mimeType) {
			const res = await fetch(config.URL_API + '/cobros_clientes/pdfRecibo/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	viajes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/facturas/viajesComprobante&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	liquidacion: {
		async create(data) {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/alta', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getAll(id) {
			const response = await fetch(config.URL_API + '/cuentas_fleteros/liquidar/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/liquidaciones_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	liquidaciones_fleteros: {
		async imprimir(id) {
			const res = await fetch(config.URL_API + '/liquidaciones_fleteros/pdfLiquidacion/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidaciones&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas: {
		async create(data) {
			const response = await fetch(config.URL_API + '/cobros_clientes/alta', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async imprimir(id, data) {
			const res = await fetch(config.URL_API + '/ventas/' + id + '/imprimir?' + data, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/pdf',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(id) {
			const response = await fetch(config.URL_API + '/cuentas_fleteros/liquidar/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	condicionventa: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/condicionventa?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	puntosdeventas: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/puntosdeventas?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	saldos: {
		async getAll() {
			const response = await fetch(config.URL_API + `/saldos`, {
				method: 'GET',
				headers: { 'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}` },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + `/saldos/${id}`, {
				method: 'GET',
				headers: { 'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}` },
			});
			const data = await response.json();
			return data;
		}
	},
	tarjetas: {
		async getAll() {
			const response = await fetch(config.URL_API + `/tarjetas`, {
				method: 'GET',
				headers: { 'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}` },
			});
			const data = await response.json();
			return data;
		}
	},
	bancos: {
		async getAll() {
			const response = await fetch(config.URL_API + `/bancos`, {
				method: 'GET',
				headers: { 'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}` },
			});
			const data = await response.json();
			return data;
		},
	},
	recibos: {
		async create(data) {
			const response = await fetch(config.URL_API + '/recibos', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}`
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	moneda: {
		async getAll() {
			const response = await fetch(config.URL_API + '/monedas', {
				method: 'GET',
				headers: { 'AUTHORIZATION': `Bearer ${sessionStorage.getItem('token')}` },
			});
			const data = await response.json();
			return data;
		}
	},
	entregas: {
		async create(data) {
			const response = await fetch(config.URL_API + '/entregas_fleteros/alta', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/entregas_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/entregas_fleteros/entrega/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async imprimir(id, mimeType) {
			const res = await fetch(config.URL_API + '/entregas_fleteros/pdfEntrega/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	estadocta: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_fleteros/saldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async PDF(params = '') {
			const res = await fetch(config.URL_API + '/cuentas_fleteros/pdfSaldos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], 'Proveedor-Saldos.pdf', { type: 'application/pdf' })
			return file;
        },
	},
};
